import { CapabilityCard } from '@thd-olt-component-react/capability_card';
import { CalloutCard } from '@thd-olt-component-react/callout_card';
import { ComponentSelector, Slot } from '@thd-olt-component-react/component-selector';
import { ContentSection } from '@thd-olt-component-react/content-section';
import { ContentAccordion } from '@thd-olt-component-react/content-accordion';
import { BrandHero } from '@thd-olt-component-react/hero';
import { MedioInline, PiccolaPencil } from '@thd-olt-component-react/internal-marketing-banner';
import { ProductShelf } from '@thd-olt-component-react/product-shelf';
import { Resource } from '@thd-olt-component-react/resource';
import { Spotlight } from '@thd-olt-component-react/spotlight';
import { VisualNavigation, PromoVisualNavigation } from '@thd-olt-component-react/visual-navigation';
import { ContentGalleryCard } from '@thd-olt-component-react/content-gallery-card';
import { SideNavigation } from '@thd-olt-component-react/side-navigation';
import { SpotlightRichText } from '@thd-olt-component-react/spotlight_rich_text';

const buildComponentMapperObj = () => {
  const contentfulTypeToComponentMap = {
    ComponentSelector,
    Gallery: ContentGalleryCard,
    BrandHero,
    Hero: BrandHero,
    MedioInline,
    PiccolaPencil,
    HeroCarousel: ContentSection,
    Section: ContentSection,
    ProductShelf,
    Resource,
    Spotlight,
    SpotlightRichTextSection: ContentSection,
    SpotlightRichText,
    Slot,
    SideNavigation,
    VisualNavigation,
    PromoVisualNavigation,
    CapabilityCard,
    CalloutCard,
    ContentAccordion
  };

  const contentfulKeyToContentKeyMap = {
    endCap: 'EndCap',
    gallery: 'gallery',
    heroCarousel: 'HeroCarousel',
    dynamicSections: 'dynamicSections',
    medioInline: 'MedioInline',
    piccolaPencil: 'PiccolaPencil',
    sideNavigation: 'SideNavigation',
    specialBuyOfTheDay: 'SpecialBuyOfTheDay',
    spotlight: 'Spotlight',
    spotlightRichTextSection: 'spotlightRichTextSection',
    slot: 'Slot',
    resource: 'Resource',
    productShelf: 'ProductShelf',
    visualNavigation: 'VisualNavigation',
    hero: 'BrandHero',
    CapabilityCard: 'CapabilityCard',
    CalloutCard: 'CalloutCard'
  };

  const contentfulKeys = Object.keys(contentfulKeyToContentKeyMap);

  return {
    getComponentMap: () => {
      return contentfulTypeToComponentMap;
    },
    getComponent: (contentfulType) => {
      return contentfulTypeToComponentMap[contentfulType];
    },
    isValidKey: (contentfulKey) => {
      return contentfulKeys.includes(contentfulKey);
    },
    getContentKey: (contentfulKey) => {
      return contentfulKeyToContentKeyMap[contentfulKey];
    }
  };
};

export const componentMapper = buildComponentMapperObj();
